import { TCustomer } from 'modules/customer/types'
import { CustomerItem } from 'schema'

import { COMPANY_LEGAL_CHAR_LENGTH, SOLE_LEGAL_CHAR_LENGTH } from '../components/CustomerAddForm/components/constants'

export const getCustomerName = (customer: TCustomer | undefined): string => {
  if (!customer) {
    return ''
  }

  return customer.type === CustomerItem.type.LEGAL ? customer.name : '–'
}

export const getCustomerInnKpp = (customer: TCustomer | undefined): string => {
  if (!customer || customer.type !== CustomerItem.type.LEGAL) {
    return ''
  }

  const inn = !customer.inn ? '' : `ИНН ${customer.inn}`
  const kpp = !customer.kpp ? '' : `КПП ${customer.kpp}`

  return [inn, kpp].filter((el) => el !== '').join(' / ')
}

export const isSoleLegal = (inn?: string) => inn?.length === SOLE_LEGAL_CHAR_LENGTH
export const isCompanyLegal = (inn?: string) => inn?.length === COMPANY_LEGAL_CHAR_LENGTH
